import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'lc-order-vouchers',
  templateUrl: './order-vouchers.component.html',
  styleUrls: ['./order-vouchers.component.scss']
})
export class OrderVouchersComponent implements OnInit {

  did_order_vouchers: boolean;
  order_did_fail: boolean;

  constructor(public dataService: DataService) { }

  ngOnInit() {
  }

  orderVouchers() {
    this.dataService.updateUserInfo({request_new_voucher_batch: true}).subscribe(res =>{
      this.did_order_vouchers = true;
      },
        error =>{
      this.did_order_vouchers = false;
      this.order_did_fail = true;
    });

  }

  orderVouchersUsingCM() {
    // TODO: add correct list ..
    this.dataService.receive_extra_vouchers('/t/j/s/vjiihr/').subscribe(res =>{
      if( res.Status == 200)
        this.did_order_vouchers = true;
      else {
        this.did_order_vouchers = false;
        this.order_did_fail = true;
      }
    }, error =>{
      this.did_order_vouchers = false;
      this.order_did_fail = true;
    });

  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/vouchers/order-vouchers/order-vouchers.component.ts